import ReactDOM from "react-dom";
import React from "react";
import { useJson } from "../../shared/utils/json";
import { text } from "../../shared/utils/i18n";
import {createRoot} from "react-dom/client";
import {getAndStripAttribute} from "../../shared/utils/dom-container-util";

const RWPLinksHomepageContainer = (props) => {
	const { parseJson, htmlDecode } = useJson();
	const model = parseJson(props.model);

	return (
		<>
			<h2>{text('replicated.favorite.links')}</h2>
			{model.map((link, i) => {
				return (
					<div key={i}><a href={link.longLink} className="btn btn-fake btn-lg">{htmlDecode(link.linkTitle)}</a></div>
				);
			})}
		</>
	);
};

const domContainer = document.querySelector('#rwp-links-homepage-container');
if (domContainer) {
  const model = getAndStripAttribute("data-model", domContainer);
  const root = createRoot(domContainer);
  root.render(<RWPLinksHomepageContainer model={model}/>);
}
